import { gql } from "@apollo/client"

const GET_STAFF_WITHOUT_SB_ACCOUNTS = gql`
  query ($input: StaffWithoutSBAccountsInput!) {
    staffWithoutSBAccounts(input: $input) {
      id
      forename
      surname
    }
  }
`

export { GET_STAFF_WITHOUT_SB_ACCOUNTS }
